import { render, staticRenderFns } from "./newSaleRma.vue?vue&type=template&id=155703f8&"
import script from "./newSaleRma.vue?vue&type=script&lang=js&"
export * from "./newSaleRma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports